import { render, staticRenderFns } from "./orderMineList.vue?vue&type=template&id=763caa4b&scoped=true"
import script from "./orderMineList.vue?vue&type=script&lang=js"
export * from "./orderMineList.vue?vue&type=script&lang=js"
import style0 from "./orderMineList.vue?vue&type=style&index=0&id=763caa4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763caa4b",
  null
  
)

export default component.exports